export default "__VITE_ASSET__DsvVho1f__"